import "../styles/projects.css";
import "../styles/global.css";
import { HiBadgeCheck } from "react-icons/hi";
import { Link } from "react-router-dom";



export default function Allprojects(props) {
    const mydata = props.data.map((data, i) => {
        return (
            <div className="projects__content" key={i + 1}>
                <h3 className="projects__title">Project number {i + 1}</h3>
                <p className="projects__subtitle">Created on {data['created_at']}</p>

                <div className="projects__box">
                    <div className="projects__groups">
                        <div className="projects__data">
                            <HiBadgeCheck className="projects_badge" />

                            <div>
                                <h3 className="projects__name">Name</h3>
                                <span className="projects__level">{data['name']}</span>
                            </div>
                        </div>

                        <div className="projects__data">
                            <HiBadgeCheck className="projects_badge" />

                            <div>
                                <h3 className="projects__name">Demo</h3>
                                <a className="projects__level" href={data['homepage']} target="_blank" rel="noreferrer">Click Here</a>
                            </div>
                        </div>

                        <div className="projects__data">
                            <HiBadgeCheck className="projects_badge" />

                            <div>
                                <h3 className="projects__name">More Info</h3>
                                <a className="projects__level" href={data['html_url']} target="_blank" rel="noreferrer">Click Here</a>
                            </div>
                        </div>
                    </div>

                    <div className="projects__groups">
                        <div className="projects__data">
                            <HiBadgeCheck className="projects_badge" />

                            <div>
                                <h3 className="projects__name">Licence</h3>
                                {data['license']?(<a className="projects__level" href={"https://google.com/search?q=" + data['license']['name']} target="_blank" rel="noreferrer">{data['license']['spdx_id']}</a>):(<p className="projects__level">None</p>)}
                            </div>
                        </div>

                        <div className="projects__data">
                            <HiBadgeCheck className="projects_badge" />

                            <div>
                                <h3 className="projects__name">stars</h3>
                                <span className="projects__level">{data['stargazers_count']}</span>
                            </div>
                        </div>

                        <div className="projects__data">
                            <HiBadgeCheck className="projects_badge" />

                            <div>
                                <h3 className="projects__name">Language</h3>
                                <span className="projects__level">{data['language']}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>)
    })

    return (
        <>
            {mydata}
            <div className="fill_projects">
                <Link to="/">
                    <div className="btn">
                        Go back
                    </div>
                </Link>
            </div>
        </>
    )
}
